module.exports = __webpack_public_path__ + "img/Apoint3.86cf5f12.png";